import AdCaller from 'helpers/ads/adCaller';
import IframeSection from 'components/Rhs/IframeSection';
import RHSRelatedVideos from 'components_v2/desktop/RHSRelatedVideos/RHSRelatedVideos';
import TwoColumnsCardWidget from 'components_v2/desktop/TwoColumnsCardWidget/TwoColumnsCardWidget';
import ETNewsLetter from 'components_v2/desktop/ETNewsLetter/ETNewsLetter';
import TabListingWidget from '../../../../components_v2/desktop/TabListingWidget/TabListingWidget';

export default {
  ad: AdCaller,
  video_widget: RHSRelatedVideos,
  column_ps_cardlist: TwoColumnsCardWidget,
  column_2_cardlist: TwoColumnsCardWidget,
  etimes_newsletter: ETNewsLetter,
  iframe: IframeSection,
  tab_list: TabListingWidget,
  // affiliatesContent: AffiliatesContent,
};
